export default __webpack_public_path__ + "static/media/wi_01d_clear_sky.eba1c47c.svg";